class Accordion {
    constructor(elem, config = {}) {
        this.elem = elem;
        this.options = {};

        if (typeof config === 'object') {
            this.options = { ...this.options, ...config };
        }

        this.init();
    }

    init() {
        const headers = document.querySelectorAll(this.elem);
        
        Array.from(headers).forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                const dataId = el.getAttribute('data-id');
                const currentContent = document.querySelector(`[data-js="accordion-content"][data-id="${dataId}"]`);
                const isActive = el.classList.contains('is-active');

                headers.forEach((el) => el.classList.remove('is-active'));
                document.querySelectorAll('[data-js="accordion-content"]').forEach((el) => el.classList.remove('is-active'));

                if (!isActive) {
                    el.classList.add('is-active');

                    if (currentContent) {
                        currentContent.classList.add('is-active');
                    }
                }
            });
        });
    }
}

const accordion = document.querySelector('[data-js="accordion"]');
if (accordion) {
    const acc = new Accordion('[data-js="accordion"] [data-js="accordion-header"]');
}